import React from 'react';
import { FormGroup, Label, TextArea, FieldHelp } from './formPrimitives';
import { useTranslation } from '../../hooks/useTranslation.jsx';

/**
 * Workshop goal — the question the whole workshop is trying to answer,
 * e.g. "Mitä pitää tehdä, jotta työnantajat palkkaisivat nuoria?".
 *
 * Stored at settings.workshopGoal and injected into judgment-making prompts as
 * {{workshopGoal}}. Required for new/edited instances: when empty, prompts
 * that use {{#if workshopGoal}} drop the block, which silently degrades
 * leverage-point and solution quality.
 */
function WorkshopGoalField({ value, onChange, disabled = false, required = true }) {
  const { t } = useTranslation();
  const trimmed = String(value || '').trim();
  const showError = required && !trimmed;

  return (
    <FormGroup>
      <Label>
        {t('instanceSettingsModal.labelWorkshopGoal')}
        {required ? ' *' : ''}
      </Label>
      <TextArea
        name="workshopGoal"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        rows={2}
        required={required}
        aria-required={required}
        aria-invalid={showError}
        placeholder={t('instanceSettingsModal.placeholderWorkshopGoal')}
      />
      <FieldHelp>{t('instanceSettingsModal.helpWorkshopGoal')}</FieldHelp>
      {showError && (
        <FieldHelp style={{ color: '#b91c1c' }}>
          {t('instanceSettingsModal.workshopGoalRequired')
            || 'Workshop goal is required — the question this workshop is answering.'}
        </FieldHelp>
      )}
    </FormGroup>
  );
}

export default WorkshopGoalField;
